import { useTranslation } from 'react-i18next';

import Modal from '@/common/components/Modal';
import { Widget } from '@/common/stores/useWidgetStore';

interface RecoveryModalProps {
  isOpen: boolean;
  onClose: () => void;
  discardedWidgets: Widget[];
  onRecover: (widget: Widget) => void;
  onCreateNew: () => void;
}

const RecoveryModal = ({
  isOpen,
  onClose,
  discardedWidgets,
  onRecover,
  onCreateNew,
}: RecoveryModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      title={t('recoveryModal.title')}
      onClose={onClose}
    >
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          {t('recoveryModal.message')}
        </p>
      </div>

      <div className="mt-4 space-y-4">
        {discardedWidgets.map((widget) => (
          <div
            key={widget.id}
            className="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer"
            onClick={() => onRecover(widget)}
          >
            <div className="font-medium">{t('recoveryModal.widgetId')} {widget.id}</div>
            <div className="text-sm text-gray-500">
              {t('recoveryModal.discardedOn')} {new Date(widget.discarded_at).toLocaleDateString()}
            </div>
            {/* You can add more widget-specific preview here based on the metadata */}
          </div>
        ))}
      </div>

      <div className="mt-4 flex justify-end space-x-3">
        <button
          className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          type="button"
          onClick={onCreateNew}
        >
          {t('recoveryModal.createNew')}
        </button>
        <button
          className="inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2"
          type="button"
          onClick={onClose}
        >
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  );
};

export default RecoveryModal;
